/**
 * Module
 */
require('./app/app.module.js');

/**
 * Constants
 */
require('./app/app.constants.js');

/**
 * Directives
 */
require('./app/widgets/cdint.directives.js');
require('./app/widgets/cdintSpinner/cdintSpinnerDrct.js');

/**
 * Services
 */

require('./app/components/servicesUtilities/labelSrvc.js');
require('./app/components/servicesUtilities/messaggiFctr.js');
require('./app/components/servicesUtilities/domainSrvc.js');
require('./app/components/servicesUtilities/userSrvc.js');
require('./app/components/servicesUtilities/loggerSrvc.js');

/**
 * Services
 */
require('./app/components/cdintPropostaCartaDebitoInt/cdintPropostaCartaDebitoIntSrvc.js');
require('./app/components/postVenditaCartaDebitoInt/postVenditaCartaDebitoIntSrvc.js');
require('./app/components/reqLottCartaDebitoInt/reqLottCartaDebitoIntSrvc.js');
require('./app/components/inquiryLottCartaDebitoInt/inquiryLottCartaDebitoIntSrvc.js');

/**
 * Components
 */
require('./app/components/cdintPropostaCartaDebitoInt/cdintModalAnnulla/cdintModalAnnulla.cmpt.js');
require('./app/components/cdintPropostaCartaDebitoInt/cdintModalRifiuta/cdintModalRifiuta.cmpt.js');

require('./app/components/cdintPropostaCartaDebitoInt/cdintDatiAggiuntivi/cdintDatiAggiuntivi.cmpt.js');
require('./app/components/cdintPropostaCartaDebitoInt/cdintDatiAml/cdintDatiAml.cmpt.js');
require('./app/components/cdintPropostaCartaDebitoInt/cdintDatiAggiuntiviPg/cdintDatiAggiuntiviPg.cmpt.js');
require('./app/components/cdintPropostaCartaDebitoInt/cdintDatiAggiuntiviPf/cdintDatiAggiuntiviPf.cmpt.js');
require('./app/components/cdintPropostaCartaDebitoInt/cdintDefinizione/cdintDefinizione.cmpt.js');
require('./app/components/cdintPropostaCartaDebitoInt/cdintSpedizione/cdintSpedizione.cmpt.js');
require('./app/components/cdintPropostaCartaDebitoInt/cdintDocumenti/cdintDocumenti.cmpt.js');
require('./app/components/cdintPropostaCartaDebitoInt/cdintQuestionari/cdintQuestionari.cmpt.js');

require('./app/components/cdintPropostaCartaDebitoInt/cdintPropostaCartaDebitoInt.cmpt.js');
// postvendita
require('./app/components/postVenditaCartaDebitoInt/postVenditaCartaDebitoInt.cmpt.js');
require('./app/components/postVenditaCartaDebitoInt/postVenditaDefinizione/postVenditaDefinizione.cmpt.js');
require('./app/components/postVenditaCartaDebitoInt/postVenditaDatiAggiuntivi/postVenditaDatiAggiuntivi.cmpt.js');

// reqLott
require('./app/components/reqLottCartaDebitoInt/reqLottCartaDebitoInt.cmpt.js');

//inquiryLott
require('./app/components/inquiryLottCartaDebitoInt/inquiryLottCartaDebitoInt.cmpt.js');

/**
 * Run
 */
require('./app/app.run.js');

/**
 * Config
 */
require('./app/app.route.js');



//////////////////
// WEBPACK FOOTER
// ./entry.js
// module id = 31
// module chunks = 0